export default __webpack_public_path__ + "static/media/marker.f3700d86.svg";